import {
  XStack,
  YStack,
  MoneyIcon,
  Heading,
  Paragraph,
  Text,
} from '@bounty/creators-design-system'
import { UserBounty_paymentSnapshot } from '@bounty/types'
import { prettyCurrency } from '@bounty/utils'
import { UserBounty_PaymentSnapshot } from '../generated/backendGraphql'

type getGiftMessageProps = {
  minBountyPayment: number | undefined | null
  hasMinPayment: boolean
  payPerView: boolean
}

export const getGiftMessage = ({
  minBountyPayment,
  hasMinPayment,
  payPerView,
}: getGiftMessageProps) => {
  if (payPerView && hasMinPayment && minBountyPayment) {
    return (
      <Heading>
        {prettyCurrency(minBountyPayment)} Guaranteed Payout{' '}
        <Heading size={'$md'} fontWeight={'$semibold'} color="$primary.600">
          when you post and additional bonuses for the views and quality of your
          post.
        </Heading>
      </Heading>
    )
  }
  if (hasMinPayment && minBountyPayment) {
    return (
      <Heading>
        {prettyCurrency(minBountyPayment)} Guaranteed Payout{' '}
        <Heading size={'$md'} fontWeight={'$semibold'} color="$primary.600">
          when you post.
        </Heading>
      </Heading>
    )
  }

  if (payPerView && !hasMinPayment) {
    return (
      <Heading>
        Get paid{' '}
        <Heading size={'$md'} fontWeight={'$semibold'} color="$primary.600">
          for the views and quality of your post.
        </Heading>
      </Heading>
    )
  }
  return null
}

type PayoutDetailsProps = {
  paymentSnapshot:
    | UserBounty_paymentSnapshot
    | UserBounty_PaymentSnapshot
    | undefined
    | null
}

export const PayoutDetailsCard = ({ paymentSnapshot }: PayoutDetailsProps) => {
  return (
    <XStack
      flex={1}
      p={'$4'}
      borderRadius="$3"
      alignItems="flex-start"
      space="$4"
    >
      <YStack
        p={'$4'}
        borderRadius="$3"
        alignItems="center"
        justifyContent="center"
        backgroundColor="$success.300"
        width={100}
        height={100}
      >
        <MoneyIcon weight="fill" size={48} color="$success.800" />
      </YStack>
      <YStack
        flexShrink={1}
        borderColor={'$neutral.200'}
        borderWidth={1}
        borderRadius="$3"
        backgroundColor={'$neutral.50'}
        py="$3"
        px="$4"
      >
        {paymentSnapshot?.productGiftConfig &&
          getGiftMessage({
            minBountyPayment: paymentSnapshot?.minBountyPayment,
            hasMinPayment:
              paymentSnapshot?.productGiftConfig?.hasMinPayment ?? false,
            payPerView:
              paymentSnapshot?.productGiftConfig?.payPerViews ?? false,
          })}
      </YStack>
    </XStack>
  )
}

export const PayoutInfoStorefront = () => {
  return (
    <YStack
      backgroundColor={'$neutral.50'}
      borderRadius="$5"
      py="$10"
      px="$6"
      pb="$6"
      borderWidth={1}
      borderColor="$neutral.300"
      alignItems="center"
    >
      <Paragraph mb="$2" textAlign="center" fontWeight="$semibold" size="$2xl">
        Up to{' '}
        <Text
          fontFamily={'$heading'}
          style={{ fontSize: 24 }}
          color="rgba(92, 225, 230, 1)"
        >
          {prettyCurrency(1000)}
        </Text>{' '}
        per video
      </Paragraph>
      <Paragraph mb="$2" textAlign="center" size="$xl">
        (Your reward will depend on the quality of your video)
      </Paragraph>
    </YStack>
  )
}
